import { cva } from '@/styled-system/css';

export const datePickerBackdropRecipe = cva({
  variants: {
    modal: {
      true: {
        display: 'grid',
        placeItems: 'center',
        zIndex: 'datePicker',
        animation: 'fade 0.2s ease-out',
        blockSize: 'auto',
        maxBlockSize: 'none',
        inlineSize: 'auto',
        maxInlineSize: 'none',
        paddingBlock: 'DatePicker.Backdrop.padding.default.vert',
        paddingInline: 'DatePicker.Backdrop.padding.default.horz',

        _before: {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'DatePicker.Backdrop.bg',
          zIndex: 1,
        },
      },
      false: {},
    },
  },
});
